import { Box, Separator, Stack } from '@chakra-ui/react'
import { memo } from 'react'
import { NavLink } from 'react-router-dom'

import NavButton from './navButton'

import useCustomerSubscription from '@app/hooks/useCustomerSubscription'
import useStoreCurrentUser from '@app/hooks/useStoreCurrentUser'
import CustomerDrawer from '@app/shared/customerDrawer'
import FavoritesSidebarList from '@app/shared/layout/shells/components/favoritesSidebarList'
import FreeTrialAlert from '@app/shared/layout/shells/components/freeTrialAlert'
import SidebarMenu from '@app/shared/layout/shells/components/sidebarMenu'
import ICON_MAP from '@app/utils/iconMap'
// import CompanyLogo from './companyLogo'

const Sidebar = () => {
  const { user } = useStoreCurrentUser()
  const subscription = useCustomerSubscription()

  return (
    <Stack as="section" justifyContent="space-between" direction="column" h="100%" w="100%">
      <Box overflowY="auto" px={{ base: '2', sm: '4' }} py={{ base: '4', sm: '4' }}>
        <Stack gap={{ base: '4', sm: '6' }}>
          {/* <CompanyLogo organization={user?.organization} /> */}
          <Stack gap={1}>
            <NavButton as={NavLink} label="Maps" icon={ICON_MAP.StrategyMap} to="/maps" />
            <CustomerDrawer>
              <NavButton label="Customers" icon={ICON_MAP.Customer} />
            </CustomerDrawer>
          </Stack>
          <Separator />
          <FavoritesSidebarList />
        </Stack>
      </Box>

      <Stack>
        {subscription && <FreeTrialAlert subscription={subscription} />}
        {user && <SidebarMenu user={user} />}
      </Stack>
    </Stack>
  )
}

export default memo(Sidebar)
